import { MaskPopupProps, MaskPopupChildrenProps } from "./types"
import React from "react"
import { Mask } from "~widgets/mask"
import styled from '~/ui/styled'

const Popup = styled.Modal``

const Container = styled.View`
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 100%;
`

const Box = styled.View`
  width: 80%;
  max-width: 360px;
  background-color: transparent;
`

const MaskPopup: React.FC<MaskPopupProps> = ({ visible, setVisible, children }) => {
  const stopContentClick = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  return (
    <Popup visible={visible} animationType="fade" transparent={true}>
      <Container>
        <Mask onClick={() => setVisible(false)} justifyContent="center">
          <Box onClick={stopContentClick}>
            {React.cloneElement<MaskPopupChildrenProps>(children as React.ReactElement<any>, {
              setVisible,
            })}
          </Box>
        </Mask>
      </Container>
    </Popup>
  )
}

export default MaskPopup
